import * as React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@wix/design-system';
import { ChangePlanModalContext } from '../../../ChangePlanModalContext';

export const ChangeDeclinePlanModalSummary: React.FC = () => {
  const { changePlanDetails } = React.useContext(ChangePlanModalContext);
  const currentPlanName =
    changePlanDetails.currentPlanDetails.localizedProductName;
  const destinationPlanName =
    changePlanDetails.destinationProductDetails.localizedProductName;
  return (
    <>
      <Text size='small' data-testid='declined_service_message'>
        <Trans
          i18nKey='change_plan.change_plan_modal.declined_service_message'
          values={{
            currentPlan: currentPlanName,
            destinationPlan: destinationPlanName,
          }}
          components={{
            bold: <strong />,
            br: <br />,
          }}
        />
      </Text>
    </>
  );
};
